import React, {
  PropsWithChildren,
  useCallback,
  useMemo,
} from "react";
import { createContext } from "react";
import {
  IElectionRound,
  ELECTION_STATUS,
  VOTING_ROUND_STATUS,
  ApiBallot,
  ISubmitStateMap,
} from "../../domain/election";
import { Loading } from "../../components/loading";
import { IVoter } from "../../domain/voter";
import { sortDisplayOrder } from "./util";
import { BALLOT_STATUS } from "../../domain/ballot-api";
import { IBallotSubmission } from "../../domain/ballot-submission";
import { AxiosResponse } from "axios";

export enum INTERFACE_STATE {
  LOADING = "LOADING",
  VOTING_ALLOWED = "VOTING_ALLOWED",
  ALREADY_SUBMITTED = "ALREADY_SUBMITTED",
  ELECTION_NOT_YET_OPEN = "ELECTION_NOT_YET_OPEN",
  ELECTION_ALREADY_CLOSED = "ELECTION_ALREADY_CLOSED",
}

const allPagesSubmitted = (ballotStatus?: ISubmitStateMap) => {
  if (!ballotStatus) {
    return false;
  }
  for (const page of Object.values(ballotStatus)) {
    if (!page.self_submitted) {
      return false;
    }
  }
  return true;
}

export interface SubmitResult {
  success: boolean;
  message?: string;
  code: string;
}

export interface IElectionContext {
  election: IElectionRound;
  ballots: Array<ApiBallot>;
  submitStateMap: ISubmitStateMap;
  interfaceState: INTERFACE_STATE;
  submitBallot: (ballotSubmission: IBallotSubmission) => Promise<AxiosResponse>;
  voter: IVoter;
}

export const ElectionContext = createContext<IElectionContext>({
  election: {} as any,
  ballots: [],
  submitStateMap: {},
  interfaceState: INTERFACE_STATE.LOADING,
  submitBallot: (ballotSubmission: IBallotSubmission) => { throw new Error("Not initialized") },
  voter: {} as any,
});